var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_qwNotify"},[_c('div',{staticClass:"contBox",domProps:{"innerHTML":_vm._s(_vm.contData)}}),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }